import { useState } from "react";

import { Button, Typography, useTheme } from "@mui/material";
import Card from "components/elements/Card";
import { CoinsStacked } from "components/icons";
import LinkedStrategyCard from "components/modules/LinkedStrategyCard";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ILinkedGridBot } from "types/types";

import LinkModal from "./Modal";

interface IProps {
  id: string;
  linkedDcaBot?: ILinkedGridBot | null;
  currencyPair: string;
  refreshData: () => void;
}

const LinkedDcaStrategy = ({ id, linkedDcaBot, currencyPair, refreshData }: IProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card
      header={t("gridBot.linkedDcaStrategy.title")}
      sx={{ mb: 0 }}
      bottomSection={
        linkedDcaBot ? (
          <Button
            color="success"
            disableElevation
            startIcon={<CoinsStacked fontSize="inherit" />}
            variant="contained"
            onClick={() => setIsOpen(true)}>
            {t("gridBot.linkedDcaStrategy.edit")}
            {"..."}
          </Button>
        ) : (
          <Button
            color="success"
            disableElevation
            startIcon={<CoinsStacked fontSize="inherit" />}
            variant="contained"
            onClick={() => setIsOpen(true)}>
            {t("gridBot.linkedDcaStrategy.link")}
            {"..."}
          </Button>
        )
      }>
      {linkedDcaBot ? (
        <LinkedStrategyCard
          color={theme.palette.tertiary.main}
          icon={<CoinsStacked />}
          exchangeTitle={linkedDcaBot.exchangeTitle}
          exchangeConnectionLabel={linkedDcaBot.exchangeConnectionLabel}
          currencyPair={currencyPair}
          label={linkedDcaBot.label}
          detailLabel={t("gridBot.linkedDcaStrategy.detail")}
          onDetail={() => navigate(`/strategie/${linkedDcaBot.id}`)}
        />
      ) : (
        <Typography variant="body2" color="secondary.main">
          {t("gridBot.linkedDcaStrategy.empty")}
        </Typography>
      )}
      {isOpen && (
        <LinkModal
          id={id}
          handleClose={() => setIsOpen(false)}
          currencyPair={currencyPair}
          refreshData={refreshData}
          initialLinkedDcaBotId={linkedDcaBot?.id}
        />
      )}
    </Card>
  );
};

export default LinkedDcaStrategy;
